import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pt-3" }
const _hoisted_2 = { class: "open-map-container col-md-6 col-10 bg-primary-white d-flex flex-column align-items-center gap-3" }
const _hoisted_3 = { class: "title-3 text-grey-900 mt-1 col-12" }
const _hoisted_4 = { class: "buttons-small text-primary-blue mt-1" }
const _hoisted_5 = {
  style: {"height":"24px","width":"24px"},
  class: "icon tf-icon-16 text-blue-900"
}

import { ref, onMounted} from "vue";
// components
import MapComponent from "@/vue/map/components/map-v2.vue";

// Images
import mapPlaceHolder from "@/images/mapPlaceHolder.png"

// Refs

export default /*@__PURE__*/_defineComponent({
  __name: 'App-v2',
  setup(__props) {

// Vue
const isMapOpen = ref(false);

// Handlers
const handleOpenMapClick = (): void => {
	isMapOpen.value = true
	window.dispatchEvent(new Event("openMapClick"))
}

const content = window.content
const lihe = window.lihe

onMounted(() => {
	document.addEventListener("fullscreenchange", () => {
     // if we're no longer in fullscreen, hide the map component
     if (!document.fullscreenElement) {
       isMapOpen.value = false;
     }
   });
 });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "map-container d-flex justify-content-center align-items-center",
      style: _normalizeStyle([{
			'background-image': `url(${_unref(mapPlaceHolder)})`
		}, {"width":"100%","height":"400px","border-radius":"20px"}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(content)['map_location_accommodation']) + " " + _toDisplayString(_unref(lihe)?.name || ""), 1),
        _createElementVNode("button", {
          onClick: handleOpenMapClick,
          type: "button",
          class: "button-secondary bg-none border-primary-blue text-primary-blue d-flex justify-content-evenly open-map-button col-md-4 col-12"
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(content)['map_seeMap']), 1),
          _createElementVNode("div", null, [
            (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[0] || (_cache[0] = [
              _createElementVNode("use", { "xlink:href": "#___icon___marker" }, null, -1)
            ])))
          ])
        ])
      ])
    ], 4),
    (isMapOpen.value)
      ? (_openBlock(), _createBlock(MapComponent, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})